let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("65TEe")).then(() => parcelRequire('j92vM'));